// 关于设计要素跳转参数枚举

export const ELEMENT_KEYS_MAP = {
  color: '色系',
  style: '风格',
  design: '图案',
  fabric: '面料',
  fabricMaterial: '面料材质',
  fabricCraft: '面料工艺',
  accessories: '辅料',
  craft: '工艺',
  silhouette: '椭形',
  collarType: '领型',
}

export enum ELEMENT_KEYS_ENUM {
  PRICES = 'prices',
  COLOR = 'color',
  STYLE = 'style',
  DESIGN = 'design',
  FABRIC = 'fabric',
  FABRIC_MATERIAL = 'fabricMaterial',
  FABRIC_CRAFT = 'fabricCraft',
  ACCESSORIES = 'accessories',
  CRAFT = 'craft',
  SILHOUETTE = 'silhouette',
  COLLAR_TYPE = 'collarType'
}

export const ELEMENT_KEYS_MAP_BOOT = {
  color: '色系',
  style: '风格',
  fabric: '面料',
  decoration: '装饰',
  craft: '工艺',
  heel: '鞋跟',
  shoelace: '鞋带',
  upper: '鞋帮',
  toe: '鞋头',
  shoes: '开口',
  tube: '筒高',
}

export enum ELEMENT_KEYS_ENUM_BOOT{ // 鞋靴
  COLOR = 'color',
  STYLE = 'style',
  FABRIC = 'fabric',
  DECORATION = 'decoration',
  CRAFT = 'craft',
  HEEL = 'heel',
  SHOELACE = 'shoelace',
  UPPER = 'upper',
  TOE = 'toe',
  SHOES = 'shoes',
  TUBE = 'tube'
}
